<div *ngIf="settings.Environment != 0 && status !== 'online'" [ngClass]="status" class="banner-container">
  <div class="banner">
    {{ getStatusMessage(status) }}
  </div>
</div>
